import React from 'react';
import AnimatedSection from './AnimatedSection';

interface ProcessStep {
  stepNumber: number;
  title: string;
  description: string;
  color: string;
}

const HowItWorksSection: React.FC = () => {
  const steps: ProcessStep[] = [
    {
      stepNumber: 1,
      title: '学习模型',
      description: '在模型工厂中学习各种思维模型，记录笔记，与AI交流',
      color: 'bg-blue-500',
    },
    {
      stepNumber: 2,
      title: '实践训练',
      description: '通过案例分析练习进行实际训练，获得AI评价和建议',
      color: 'bg-purple-500',
    },
    {
      stepNumber: 3,
      title: '持续提升',
      description: '查看学习记录，跟踪进度，持续提升思维能力',
      color: 'bg-green-500',
    },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            如何开始
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            三步开始你的思维提升之旅
          </p>
        </div>

        <div className="relative">
          {/* 连接线 - 仅在桌面端显示 */}
          <div className="hidden md:block absolute top-16 left-1/2 transform -translate-x-1/2 w-full max-w-3xl">
            <div className="flex justify-between items-center">
              <div className="w-8 h-8"></div>
              <div className="flex-1 h-0.5 bg-gray-200 mx-4"></div>
              <div className="w-8 h-8"></div>
              <div className="flex-1 h-0.5 bg-gray-200 mx-4"></div>
              <div className="w-8 h-8"></div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative z-10">
            {steps.map((step, index) => (
              <AnimatedSection
                key={index}
                animation="slide-up"
                delay={index * 200}
              >
                <div className="text-center">
                  <div className={`w-16 h-16 ${step.color} rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg hover:scale-110 transition-transform duration-300 animate-float`}>
                    <span className="text-2xl font-bold text-white">{step.stepNumber}</span>
                  </div>
                  
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    {step.title}
                  </h3>
                  
                  <p className="text-gray-600 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;